(function () {
  'use strict';

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest('.scroll-area, .product-list, slideshow-carousel, scroll-carousel')) {
      e.preventDefault();
    }
  });

  var DRAG_THRESHOLD = 6;

  function initDragScroll(container) {
    if (container.__dragScrollInit) return;
    container.__dragScrollInit = true;

    var isDown = false;
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;

    container.addEventListener('pointerdown', function (e) {

      if (e.pointerType !== 'mouse' || e.button !== 0) return;

      isDown = true;
      isDragging = false;
      startX = e.clientX;
      scrollStart = container.scrollLeft;
      container.classList.add('is-grabbing');
    });

    container.addEventListener('pointermove', function (e) {
      if (!isDown) return;

      var diff = e.clientX - startX;

      if (!isDragging && Math.abs(diff) > DRAG_THRESHOLD) {
        isDragging = true;
        container.setPointerCapture(e.pointerId);
      }

      if (isDragging) {
        e.preventDefault();
        container.scrollLeft = scrollStart - diff;
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      container.classList.remove('is-grabbing');

      if (isDragging) {

        var blockClick = function (evt) {
          evt.stopPropagation();
          evt.preventDefault();
        };
        container.addEventListener('click', blockClick, { capture: true, once: true });
        setTimeout(function () {
          container.removeEventListener('click', blockClick, { capture: true });
        }, 50);
      }
      isDragging = false;
    }

    container.addEventListener('pointerup', endDrag);
    container.addEventListener('pointercancel', endDrag);
    container.addEventListener('pointerleave', endDrag);
  }

  function initAll() {
    document.querySelectorAll('.scroll-area').forEach(initDragScroll);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);

  var observer = new MutationObserver(function () {
    initAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
